import React from 'react';
import {IconProps} from './types';

export const User = ({width, height, color, ...props}: IconProps) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="3.5" stroke={color} strokeWidth="2"/>
            <path
                d="M5 19.5C5 16.4624 8.13401 14.5 12 14.5C15.866 14.5 19 16.4624 19 19.5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};
